const itMessages = {
  /* 01.General */
  "main.name": "Nome",
  "main.sentiment": "Sentimento",
  "main.urgency": "Urgenza",
  "main.language": "Lingua",
  "main.agent": "Agente",
  "main.property_name": "Nome della struttura",
  "main.booking_number": "Numero di prenotazione",
  "main.check_out": "Check-out",
  "main.check_in": "Check-in",
  "main.adults": "Adulti",
  "main.corporate_code": "Codice aziendale",
  "main.group_code": "Codice gruppo",
  "main.promo_code": "Codice promozionale",
  "main.ai_response": "Risposta AI",
  "main.template_response": "Risposta modello",
  "main.converttoticket": "Converti in ticket",
  "main.switch_property": "Cambia struttura",
  "main.Group_id": "ID gruppo",
  "main.integration_id": "ID integrazione",
  "main.submit": "Invia",
  "main.cancel": "Annulla",
    "main.select_template": "Seleziona un modello",
  "main.rooms": "Camere",
  "main.rates": "Tariffe",

  //footer
    "footer.knowledge": "Conoscenza",
  "footer.home": "Home",
  "footer.help": "Aiuto",

//ticket
  "ticket.thank_you": "Grazie per aver inviato il modulo",
  "ticket.ticket": "Ticket",
  "ticket.details": "Compila il modulo descrivendo i dettagli del ticket.",
  "ticket.select_category": "Seleziona categoria",
  "ticket.category": "Categoria",
  "ticket.title": "Titolo",
  "ticket.notes": "Note",
  "ticket.status": "Stato",
  "ticket.assigned_to": "Assegnato a",
  "ticket.submit_form": "Invia modulo",


  "main.total": "Totale",
  "main.pastetooutlook": "Incolla in Outlook",
  "main.children": "Bambini",
  "main.promocode": "Codice Promo/Aziendale/Gruppo",
  "main.exact_match_only": "Solo corrispondenza esatta",
  "main.search": "Cerca",
  "main.no_rate_match": "Nessuna tariffa corrisponde alla selezione effettuata. Modifica la ricerca e riprova.",
  "main.translate_to": "Traduci in",
  "main.regenerate": "Rigenera",
  "main.copy_text": "Copia testo",
  "main.additional_instructions": "Istruzioni aggiuntive",

  "faq.helpcenter": "Centro assistenza",
  "faq.reply.email.sabre.question": "Come posso rispondere a un'e-mail utilizzando Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Apri l'e-mail e avvia il componente aggiuntivo Aven Hospitality. Puoi scegliere tra tre opzioni: utilizzare un modello predefinito, generare una risposta AI o convertire l'e-mail in un ticket. Seleziona l'opzione più adatta, controlla la risposta, apporta modifiche se necessario e inviala direttamente da Outlook.",

  "faq.rates.availability.question": "Come posso aggiungere tariffe, disponibilità e dettagli delle camere alla mia risposta?",
  "faq.rates.availability.answer": "Utilizza la funzione + Rates per inserire i dettagli degli ospiti come date e numero di persone. Concierge inserirà disponibilità e prezzi accurati nella risposta. Puoi anche utilizzare + Rooms per aggiungere descrizioni e immagini delle camere.",

  "faq.different.language.question": "Cosa devo fare se l'e-mail è in una lingua diversa?",
  "faq.different.language.answer": "Aven Hospitality Concierge consente di tradurre le e-mail in arrivo nella lingua preferita.",

  "faq.pin.addin.question": "Come posso assicurarmi che il componente aggiuntivo sia sempre disponibile in Outlook?",
  "faq.pin.addin.answer": "Per mantenere Aven Hospitality Concierge sempre visibile, aggiungi il componente aggiuntivo ai preferiti in Outlook.",

  "faq.knowledge.hub.question": "Cos'è l'opzione di ricerca Knowledge Hub?",
  "faq.knowledge.hub.answer": "La ricerca Knowledge Hub consente di trovare rapidamente informazioni specifiche della struttura direttamente in Outlook.",

  "faq.reply.email.myma.question": "Come posso rispondere a un'e-mail utilizzando Myma?",
  "faq.reply.email.myma.answer": "Apri l'e-mail e avvia il componente aggiuntivo Myma. Puoi utilizzare un modello, generare una risposta AI o convertire l'e-mail in un ticket.",

  "faq.room.details.question": "Come posso aggiungere dettagli delle camere alla mia risposta?",
  "faq.room.details.answer": "Utilizza + Rooms per includere descrizioni e immagini delle camere.",

  "faq.myma.different.language.question": "Cosa devo fare se l'e-mail è in una lingua diversa?",
  "faq.myma.different.language.answer": "Myma consente di tradurre le e-mail ricevute nella lingua preferita.",

  "faq.myma.pin.addin.question": "Come posso assicurarmi che il componente aggiuntivo sia sempre disponibile in Outlook?",
  "faq.myma.pin.addin.answer": "Aggiungi il componente aggiuntivo Myma in Outlook per aprirlo automaticamente con ogni e-mail.",

};

export default itMessages;
